import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  helper: {
    marginTop: 16,
    padding: '8px 16px 8px 24px',
    position: 'relative',
    border: 'none !important',
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(19, 45, 74, 0.04)',
    borderRadius: '8px !important',
  },
  sideBorder: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 8,
    height: '100%',
    background: theme.palette.primary.main,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
  },
  helperAgentName: {
    textTransform: 'capitalize',
  },
}))
